import { useResponsive } from '@/hooks';
import { type LanguageCode, ResponsiveCollection } from '@/interfaces';

interface StoreBadgeProps {
  platform: 'apple' | 'google';
  url?: string;
  languageCode: LanguageCode;
  width?: number;
  height?: number;
  onClick?: () => void;
  'data-testid'?: string;
}

const StoreBadge = ({
  platform = 'apple',
  url,
  languageCode,
  width,
  height,
  onClick,
  'data-testid': dataTestId,
}: StoreBadgeProps) => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  const getImgSrc = () => {
    return `/images/app-badges/${languageCode}/${platform}-black-${languageCode}.svg`;
  };

  const storeBadge = (
    <img
      src={getImgSrc()}
      alt={`${platform} badge`}
      width={width ?? 'auto'}
      height={height ?? (isDesktopPMT ? 60 : 45)}
    />
  );

  if (!url) return storeBadge;

  return (
    <a href={url} target='_blank' rel='noreferrer' onClick={onClick} data-testid={dataTestId}>
      {storeBadge}
    </a>
  );
};

export default StoreBadge;
